import NotFound from "@pages/not-found";
import { getSession } from "@shared/lib/supabase/get-session";
import { createRootRoute, Outlet, redirect } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";

export const Route = createRootRoute({
	beforeLoad: async ({ location }) => {
		const session = await getSession();
		const isLoginPage = location.pathname === "/login";

		if (!(session || isLoginPage)) {
			throw redirect({ to: "/login" });
		}

		if (session && isLoginPage) {
			throw redirect({ to: "/" });
		}
	},
	component: () => (
		<>
			<Outlet />
			<TanStackRouterDevtools position="bottom-right" />
		</>
	),
	notFoundComponent: NotFound,
});
